import { useExecute } from '@40seas/frontend/libs/hooks';
import { useHubspot } from 'frontend/apps/dashboard/src/hooks/useHubspot';
import { useAuth } from 'frontend/apps/dashboard/src/hooks/useAuth';
import * as React from 'react';

const HubspotWidget = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const { isAuthenticated } = useAuth();
    const { user, createVisitorIdentificationToken } = useHubspot();

    // Hubspot sandbox doesn't exist so we need to ignore the token in localhost
    const isLocalhost = typeof window !== 'undefined' && window?.location?.hostname === 'localhost';

    useExecute(
        () => {
            if (!isAuthenticated) return;

            if (isLocalhost) window.HubSpotConversations.widget.load();
            else {
                void createVisitorIdentificationToken().then((token) => {
                    if (token) {
                        window.hsConversationsSettings = {
                            identificationEmail: user?.email,
                            identificationToken: token,
                        };

                        window.HubSpotConversations.widget.load();
                    }
                });
            }
        },
        () => !!window.HubSpotConversations,
    );

    return <>{children}</>;
};

export default HubspotWidget;

declare global {
    interface Window {
        hsConversationsSettings: {
            loadImmediately?: boolean;
            identificationEmail?: string;
            identificationToken?: string;
        };
        HubSpotConversations: {
            widget: {
                load: () => void;
            };
        };
    }
}
